<div class="select-container" [class.disabled]="disabled">
  @if (label) {
    <hyperkit-typography
      class="select-label"
      variant="emphasized"
      size="sm"
      color="inherit"
    >
      {{ label }}
      @if (isRequired) {
        <span class="required-asterisk">*</span>
      }
    </hyperkit-typography>
  }

  <div class="select-wrapper">
    <!-- Main select field -->
    <div
      class="select-field"
      [class.active]="state === 'active' && !disabled"
      [class.hover]="state === 'hover' && !disabled"
      [class.focused]="state === 'focused' && !disabled"
      [class.filled]="state === 'filled' && !disabled"
      [class.inactive]="state === 'inactive' || disabled"
      [class.error]="hasError && !disabled"
      (click)="!disabled && toggleDropdown()"
      (mouseenter)="!disabled && onMouseEnter()"
      (mouseleave)="!disabled && onMouseLeave()"
      tabindex="0"
      (keydown.enter)="!disabled && toggleDropdown()"
      (keydown.space)="!disabled && toggleDropdown()"
    >
      <div class="select-value">
        <hyperkit-typography
          [class.placeholder]="!selectedDisplayText"
          variant="body"
          size="md"
          color="inherit"
        >
          {{ selectedDisplayText || placeholder }}
        </hyperkit-typography>
      </div>

      <div class="select-arrow">
        <hyperkit-icon
          icon="chevron-down"
          color="inherit"
          size="medium"
        ></hyperkit-icon>
      </div>
    </div>
  </div>

  <!-- Dropdown options -->
  @if (isOpen && !disabled) {
    <div
      class="select-dropdown"
      [class.absolute]="dropdownPosition === 'absolute'"
      [ngStyle]="dropdownPosition === 'fixed' ? dropdownStyle : null"
    >
      <hyperkit-dropdown-menu [isVisible]="isOpen">
        @if (sectionHeader) {
          <hyperkit-dropdown-menu-section-header
            [label]="sectionHeader"
          ></hyperkit-dropdown-menu-section-header>
        }
        @for (option of internalOptions; track option) {
          <hyperkit-dropdown-menu-item
            [label]="option.text"
            [selected]="
              (selectedOption && option.id === selectedOption.id) || false
            "
            (click)="selectOption(option)"
            (keydown.enter)="selectOption(option)"
            (keydown.space)="selectOption(option)"
          >
          </hyperkit-dropdown-menu-item>
        }
      </hyperkit-dropdown-menu>
    </div>
  }
  @if (hint) {
    <div class="hint-container">
      <hyperkit-typography variant="body" size="sm" color="inherit">
        {{ hint }}
      </hyperkit-typography>
    </div>
  }
  @if (hasError) {
    <hyperkit-error>
      {{ errorMessage }}
    </hyperkit-error>
  }
</div>
